// extracted by mini-css-extract-plugin
module.exports = {"ant-layout-sider-trigger":"style_ant-layout-sider-trigger__1opOP","dropdown":"style_dropdown__1vclY","avatar":"style_avatar__2tCdI","menuIcon":"style_menuIcon__3EfQ-"};